import {
  FETCH_DRIVER_INIT,
  FETCH_DRIVER_SUCCESS,
  FETCH_DRIVER_FAILURE,
  FETCH_EQUIP_INIT,
  FETCH_EQUIP_SUCCESS,
  FETCH_EQUIP_FAILURE,
  FETCH_TEST_INIT,
  FETCH_TEST_SUCCESS,
  FETCH_TEST_FAILURE,
  IF_DRIVER_EXIST,
  ADD_ASIGNATION,
  DELETE_ASIGNATION,
  CHANGE_NAME,
  IS_DUPLICATE
} from './types';
import API from './api';

// adding asignation to the redux state
export function addAsignation(asignation) {
  return dispatch => {
    return dispatch({
      type: ADD_ASIGNATION,
      payload: asignation
    });
  };
}

// verified that a driver or a truck is not duplicate in the asignations
export function isDuplicate(name) {
  return dispatch => {
    return dispatch({
      type: IS_DUPLICATE,
      payload: name
    });
  };
}
// change driver name to disable/enable validation component
export function changeName(obj) {
  return dispatch => {
    return dispatch({
      type: CHANGE_NAME,
      payload: obj
    });
  };
}

export function deleteAsignation(id) {
  return dispatch => {
    return dispatch({
      type: DELETE_ASIGNATION,
      payload: id
    });
  };
}

function fetchDriverInit() {
  return {
    type: FETCH_DRIVER_INIT
  };
}

function fetchDriverFailure(err) {
  return {
    type: FETCH_DRIVER_FAILURE,
    payload: err
  };
}

/* Asignador get */

function fetchDriverSuccess(data) {
  return {
    type: FETCH_DRIVER_SUCCESS,
    payload: data
  };
}

export function fetchDriver() {
  return async dispatch => {
    dispatch(fetchDriverInit());
    try {
      const data = await API.data.getDrivers();
      dispatch(fetchDriverSuccess(data));
    } catch (err) {
      dispatch(fetchDriverFailure(err));
    }
  };
}

/*get all the equip*/
function fetchEquipInit() {
  return {
    type: FETCH_EQUIP_INIT
  };
}

function fetchEquipFailure(err) {
  return {
    type: FETCH_EQUIP_FAILURE,
    payload: err
  };
}

/* Asignador get */

function fetchEquipSuccess(data) {
  return {
    type: FETCH_EQUIP_SUCCESS,
    payload: data
  };
}

export function fetchEquip() {
  return async dispatch => {
    dispatch(fetchEquipInit());
    try {
      const data = await API.data.getEquip();
      dispatch(fetchEquipSuccess(data));
    } catch (err) {
      dispatch(fetchEquipFailure(err));
    }
  };
}

/*test endpoint*/
/*get all the equip*/
function fetchTestInit() {
  return {
    type: FETCH_TEST_INIT
  };
}

function fetchTestFailure(err) {
  return {
    type: FETCH_TEST_FAILURE,
    payload: err
  };
}

function fetchTestSuccess(data) {
  return {
    type: FETCH_TEST_SUCCESS,
    payload: data
  };
}

export function fetchTest() {
  return async dispatch => {
    dispatch(fetchTestInit());
    try {
      const data = await API.data.getTest();
      dispatch(fetchTestSuccess(data));
    } catch (err) {
      dispatch(fetchTestFailure(err));
    }
  };
}

//check if a driver is duplicated and its just a testDrier

export function checkIfExist(alias) {
  return dispatch => {
    dispatch({
      type: IF_DRIVER_EXIST,
      payload: alias
    });
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/allocator/index.js